import filesize from 'convert-size';

export const sizeToText = (size: number) =>
  filesize(size, {
    accuracy: 2,
  });
export const maxUploadSize = filesize('10 MB');
export const maxUploadCount = 10;
export const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png'] as const;
export const allowedMimeTypes = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'application/pdf',
];
export const errorMessages = {
  uploadSizeLimit: `Per favore carica file non superiori a ${filesize(
    maxUploadSize,
  )}`,
  uploadCountLimit:
    'Hai superato il limite di file che possono essere caricati',
  incompatibleFormat: 'Il formato del file che hai caricato non è compatibile',
  genericError: 'Non è stato possibile caricare il file',
  fileDuplicate:
    'Uno o più file sono dupplicati e per questo non sono stati caricati',
  corruptedFile: 'File danneggiato o incompatibile',
};
